/* Responsibility: Massage filterdata before view rendering. */
import fn from '../../lib/fn.js';
import { thousandSeparated } from '../../lib/formatting.js';

const T = FINN.travel;

function formatCount(data) {
    fn.forEach(data, (item) => {
        item.count = thousandSeparated(item.count || 0);
        if (item.children) {
            formatCount(item.children);
        }
    });
}

const prepareFilter = {
    airport(data) {
        if (data.airportFacet) {
            formatCount(data.airportFacet);
        }
    },
    supplier(data) {
        if (data.supplierFacet) {
            if (data.supplierFacet.charter) {
                formatCount(data.supplierFacet.charter);
            }
            if (data.supplierFacet.nonCharter) {
                formatCount(data.supplierFacet.nonCharter);
            }
        }
    },
    tripType(data) {
        if (data.typeFacet) {
            formatCount(data.typeFacet);
        }
        const friendlyName = {
            uspesifisert: T.lang.unspecified_lodging,
            spesifisert: T.lang.specified_lodging,
            fly: T.lang.flight_only,
            enveisfly: T.lang.one_way_flight,
        };
        fn.forEach(data.typeFacet, (item) => {
            item.text = friendlyName[item.name] || item.name;
        });
    },
};

export default prepareFilter;
